<template>
<div class="chapter">
<div class="inner_page">
<div class="cover font-AtmaSerif-MediumRoman-5_1-12">
<a id="cover">
<div class="cover_image"><div class="image_wrap"><img alt="e9780811866989_cover.jpg" src="images/e9780811866989_cover.jpg"/></div></div></a><a id="title18"></a></div>
<a id="title18">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001cover.vue?79c2e942